import { render, staticRenderFns } from "./expand_collapse_button.vue?vue&type=template&id=66bac7cb"
import script from "./expand_collapse_button.vue?vue&type=script&lang=js"
export * from "./expand_collapse_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports